<ng-container *ngIf="currentOffer$ | async as details">
  <div>
    <div class="flex flex--space-between flex--middle">
      <h1 class="pr-large-y font-heading-3 ms-clear bold-type nordic-blue-900-text">
        {{ 'ticketSelection.reviewFlights' | finLocalization }}
      </h1>
    </div>
    <fin-flight-card
      *ngFor="let boundSummary of boundSummary$ | async; let first = first; let i = index"
      class="block"
      [ngClass]="{
        'pr-xsmall-t': !first,
      }"
      [attr.data-testid]="'pax-flight-review-bound-' + i"
      [flightOrBound]="boundSummary.bound"
      [title]="
        'bookingSummary.boundTitle'
          | finLocalization
            : {
                index: i + 1,
                departureCity: boundSummary.departureCity,
                arrivalCity: boundSummary.arrivalCity,
              }
      "
      [locations]="details.locations"
      [passengers]="details.passengers"
      (viewDetails)="showTicketSummaryModal(boundSummary)"
      (modifyClicked)="returnToFlightSelection()"
    />

    @if (isVariantB()) {
      <fcom-notification
        class="pr-xsmall-t"
        data-testid="24-hour-money-back-notification"
        [theme]="NotificationTheme.SUSTAINABILITY"
        [scale]="NotificationScale.LARGE"
        [iconName]="SvgLibraryIcon.TWENTY_FOUR_HOUR_REFUND"
        [buttonStyle]="NotificationButtonStyle.LINK"
        [linkText]="'viewDetails' | finLocalization"
        [horizontal]="true"
        (linkClick)="showModal($event)"
      >
        <span
          class="content-description"
          [innerHTML]="'moneyBackHighlightB' | finLocalization | finSafe: 'html'"
        ></span>
      </fcom-notification>
    }
  </div>

  <fcom-modal
    class="ticket-summary-modal"
    [title]="'ticketSelection.flightsAndBenefits.title' | finLocalization"
    [buttons]="ModalButtons.DONE"
    [open]="ticketSummaryModal.open"
    (close)="closeModals()"
  >
    <fcom-tabs
      [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
      [nextButtonAriaLabel]="'carousel.next' | finLocalization"
      [layoutType]="TabLayoutType.IN_MODAL"
    >
      <fcom-tab [title]="'fareFamilyDetails.title' | finLocalization">
        <fin-fare-family-details
          class="block pr-medium"
          [fareFamilies]="[details.benefits[ticketSummaryModal.bound?.fareFamilyCode]]"
        />
      </fcom-tab>
      <fcom-tab [title]="'itinerary.title' | finLocalization">
        <fin-itinerary-timeline
          class="block pr-medium"
          [locations]="details.locations"
          [bound]="ticketSummaryModal.bound"
          [boundType]="ticketSummaryModal.boundType"
          [isBookingFlow]="true"
        />
      </fcom-tab>
    </fcom-tabs>
  </fcom-modal>

  @if (isVariantB()) {
    <fcom-modal
      data-testid="24-hour-money-back-modal"
      [(open)]="modalOpen"
      [title]="(content$ | async)?.teaserTitle"
      [buttons]="ModalButtons.CLOSE"
      (close)="closeModal()"
    >
      <cms-unstyled-fragment class="block pr-medium" [cmsContent$]="content$" [showTitle]="false" />
    </fcom-modal>
  }
</ng-container>
